import { render, staticRenderFns } from "./viajeIndex.vue?vue&type=template&id=1788c4b6"
import script from "./viajeIndex.vue?vue&type=script&lang=js"
export * from "./viajeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports